export default {
  SET_TUTOR_EARNINGS(state, array) {
    state.earnings = array;
  },
  SET_DASHBOARD_EARNINGS(state, object) {
    state.dashboard_earnings = object;
  },
};



// WEBPACK FOOTER //
// ./src/store/earnings/mutations.js